export default __webpack_public_path__ + "static/media/CONSTRUCCION_TABLET_IMG.11ab5b41.jpg";